export const AUTO_FILL_APPLICATION = 'AUTO_FILL_APPLICATION'
export const AUTO_FILL_ZIP = 'AUTO_FILL_ZIP'
export const AUTO_FILL_ENROLLEES = 'AUTO_FILL_ENROLLEES'
export const AUTO_FILL_QUALLIFY_LIFE_EVENT = 'AUTO_FILL_QUALLIFY_LIFE_EVENT'
export const DEBUG_SKIP_STEP = 'DEBUG_SKIP_STEP'
